import { render_app } from './App';
//import { enable_api_debug } from './02_api';enable_api_debug();


const theme = 'jma' ;

require( "./theme_jma.css" ) ;

render_app( theme ) ;
